import { motion } from 'motion/react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SessionCompleteProps {
  onHome: () => void;
}

export function SessionComplete({ onHome }: SessionCompleteProps) {
  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center max-w-md w-full"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
          className="w-20 h-20 bg-neutral-900 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <Check className="w-10 h-10 text-white" />
        </motion.div>
        
        <h1 className="text-4xl font-semibold text-neutral-900 mb-4">
          Workout Complete
        </h1>
        <p className="text-xl text-neutral-600 mb-8">
          Done
        </p>
        
        <Button onClick={onHome} size="lg" className="w-full">
          Return Home
        </Button>
      </motion.div>
    </div>
  );
}

